import { create } from "zustand";
import { subscribeWithSelector } from "zustand/middleware";

import { type CanvasActions, type CanvasState, createCanvasSlice, initialCanvasState } from "./slices/canvas-slice.ts";
import { createMainSlice, initialMainState, type MainActions, type MainState } from "./slices/main-slice.ts";
import {
  createRangeSelectionSlice,
  initialRangeSelectionState,
  type RangeSelectionActions,
  type RangeSelectionState,
} from "./slices/range-selection-slice.ts";
import {
  createSaveLoadSlice,
  initialSaveLoadState,
  type SaveLoadActions,
  type SaveLoadState,
} from "./slices/save-load-slice.ts";
import { createSearchSlice, initialSearchState, type SearchActions, type SearchState } from "./slices/search-slice.ts";
import {
  createTrackConfigurationSlice,
  initialTracksConfigurationState,
  type TracksConfigurationActions,
  type TracksConfigurationState,
} from "./slices/tracks-configuration-slice.ts";

export type GenomeViewerState = MainState &
  TracksConfigurationState &
  RangeSelectionState &
  CanvasState &
  SaveLoadState &
  SearchState;

export type GenomeViewerActions = MainActions &
  TracksConfigurationActions &
  CanvasActions &
  RangeSelectionActions &
  SaveLoadActions &
  SearchActions;

export type GenomeViewerStore = GenomeViewerState & GenomeViewerActions;

export const resetState: Partial<GenomeViewerState> = {
  ...initialMainState,
  ...initialCanvasState,
  ...initialTracksConfigurationState,
  ...initialRangeSelectionState,
  ...initialSaveLoadState,
  ...initialSearchState,
};

export const useGenomeViewerStore = create(
  subscribeWithSelector<GenomeViewerStore>((set, get, store) => ({
    ...createMainSlice(set, get, store),
    ...createCanvasSlice(set, get, store),
    ...createTrackConfigurationSlice(set, get, store),
    ...createRangeSelectionSlice(set, get, store),
    ...createSaveLoadSlice(set, get, store),
    ...createSearchSlice(set, get, store),
  })),
);
